import type { PaddleIntegrationConfiguration } from '@vy/integrations-types';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { PaddleConfigurationFormValues } from '../PaddleConfigurationFormSchema';

export function getPaddleIntegrationSettings(configuration: PaddleConfigurationFormValues) {
  return {
    integrationProvider: INTEGRATION_PROVIDERS.paddle,
    integrationConfiguration: mapFormValuesToPaddleSettings(configuration),
  };
}

function mapFormValuesToPaddleSettings(
  formValues: PaddleConfigurationFormValues,
): DeepPartial<PaddleIntegrationConfiguration> {
  return {
    generalConfig: {
      autoExportInvoices: formValues.autoExportInvoices,
    },
  };
}
